import { ComponentDefinition } from '@contentful/experiences-sdk-react';

export const accordionItemDefinition: ComponentDefinition = {
  id: 'accordionItemDefinition',
  name: 'Accordion - single item',
  category: 'Custom',
  thumbnailUrl: 'https://unpkg.com/lucide-static/icons/chevron-down.svg',
  variables: {
    title: {
      type: 'Text',
      displayName: 'Title',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    content: {
      type: 'RichText',
      displayName: 'Content',
      validations: {
        bindingSourceType: ['manual', 'experience', 'entry', 'asset'],
      },
    },
    size: {
      displayName: 'Text size',
      type: 'Text',
      defaultValue: 'typo-body-medium',
      group: 'style',
      validations: {
        in: [
          { value: 'typo-body-md-medium', displayName: 'Size: Medium | Weight: Bold' },
          { value: 'typo-body-md', displayName: 'Size: Medium | Weight: Normal' },
          { value: 'typo-body-sm-medium', displayName: 'Size: Small | Weight: Bold' },
          { value: 'typo-body-sm', displayName: 'Size: Small | Weight: Normal' },
        ],
      },
    },
    colorHeading: {
      displayName: 'Heading colour',
      type: 'Text',
      defaultValue: 'body-text-grey',
      group: 'style',
      validations: {
        in: [
          { value: 'headings-grey', displayName: 'Grey' },
          { value: 'headings-dark-purple', displayName: 'Purple' },
          { value: 'headings-white', displayName: 'White' },
          { value: 'headings-white-on-dark', displayName: 'White on dark' },
          { value: 'headings-pink-accent', displayName: 'Pink' },
          { value: 'headings-link-blue', displayName: 'Link blue' },
        ],
      },
    },
    colorText: {
      displayName: 'Text colour',
      type: 'Text',
      defaultValue: 'body-text-grey',
      group: 'style',
      validations: {
        in: [
          { value: 'text-text-dark-purple', displayName: 'Purple' },
          { value: 'text-text-white', displayName: 'White' },
          { value: 'text-text-white-on-dark', displayName: 'White on dark' },
          { value: 'text-text-grey', displayName: 'Grey' },
          { value: 'text-text-pink-accent', displayName: 'Pink' },
          { value: 'text-text-link-blue', displayName: 'Link blue' },
        ],
      },
    },
    colorLink: {
      displayName: 'Link colour',
      type: 'Text',
      defaultValue: 'link-link-blue',
      group: 'style',
      validations: {
        in: [
          { value: 'link-dark-purple', displayName: 'Purple' },
          { value: 'link-white', displayName: 'White' },
          { value: 'link-white-on-dark', displayName: 'White on dark' },
          { value: 'link-grey', displayName: 'Grey' },
          { value: 'link-pink-accent', displayName: 'Pink' },
          { value: 'link-link-blue', displayName: 'Link blue' },
        ],
      },
    },
    textAlign: {
      displayName: 'Text align',
      type: 'Text',
      defaultValue: 'text-center',
      group: 'style',
      validations: {
        in: [
          { value: 'text-left', displayName: 'Left' },
          { value: 'text-center', displayName: 'Center' },
          { value: 'text-right', displayName: 'Right' },
        ],
      },
    },
  },
} as const;
